import React from "react";
import { useSelector } from "react-redux";
import Parser from "html-react-parser";

const AnswerCard = ({
  option,
  type,
  title,
  answer,
  onAction,
  saveAnswereDatas,
}) => {
  const { questionLists, i, gettingAnswers } = useSelector(
    (state) => state.questionHealth
  );
  // console.log(gettingAnswers[type], "gettingAnswers[type]");
  // console.log(saveAnswereDatas[type], "이거냐!! 타입!");
  return (
    <>
      {option === 2 ? ( //2개이상 질문 페이지
        <li
          onClick={() => onAction(type, answer)}
          className={
            "rounded-2xl border p-4 text-center " +
            (saveAnswereDatas[type] === answer
              ? "bg-gray_180"
              : "border border-gray_200")
          }
        >
          <p
            className={
              saveAnswereDatas[type] === answer
                ? "text-body2_700 text-white"
                : "text-body2_700 text-gray_200"
            }
          >
            {title ? Parser(title) : ""}
          </p>
        </li>
      ) : option === 3 ? ( //한 열에 3개 문항
        <li
          onClick={() => onAction(type, answer)}
          className={
            "rounded-2xl border px-1 py-4 text-center " +
            (saveAnswereDatas[type] === answer
              ? "bg-gray_180"
              : "border border-gray_200")
          }
        >
          <p
            className={
              saveAnswereDatas[type] === answer
                ? "text-body2_700 text-white"
                : "text-body2_700 text-gray_200"
            }
          >
            {title ? Parser(title) : ""}
          </p>
        </li>
      ) : (
        <li
          onClick={() => onAction(type, answer)}
          className={
            "rounded-2xl border px-4 py-4 " +
            (saveAnswereDatas?.[questionLists[i]?.saveUserColumn] === answer
              ? "bg-gray_180 "
              : "border border-gray_200 ") +
            (type === "userType" ? "text-left" : "text-center")
          }
        >
          <p
            className={
              saveAnswereDatas?.[questionLists[i]?.saveUserColumn] === answer
                ? "text-body2_700 text-white"
                : "text-body2_700 text-gray_200"
            }
          >
            {title ? Parser(title) : ""}
          </p>
        </li>
      )}
    </>
  );
};

export default AnswerCard;
